import { map, slice, view, curryN, pipe } from "ramda"

export const globalizeSelector = (lens) => (selector) => {
  return (...args) => {
    let state = args[args.length - 1]
    let extraArgs = slice(0, args.length - 1, args)

    let localState = view(lens, state)
    return selector(...extraArgs, localState)
  }
}

export const globalizeSelectorStart = (lens) => (selector) => {
  return (...args) => {
    const [state, ...extraArgs] = args

    let localState = view(lens, state)
    return selector(localState, ...extraArgs)
  }
}

export const currySelector = (selectorLength) => (selector) => {
  return curryN(selectorLength, selector)
}

export const globalizeSelectors = (lens, selectors) => {
  return map(
    (selector) => pipe(globalizeSelector(lens), currySelector(selector.length))(selector),
    selectors,
  )
}

export const globalizeSelectorsStart = (lens, selectors) => {
  return map(
    (selector) => pipe(globalizeSelectorStart(lens), currySelector(selector.length))(selector),
    selectors,
  )
}
